import React, { useEffect, useState } from 'react';
import { CardHeader, CardSection } from '@europrocurement/flexy-components';
import { DOC_TYPE_DOWNLOADABLE } from '@europrocurement/l2d-domain';
import { useDossierDocumentsCtx } from '@europrocurement/l2d-modules/providers';
import { useSelectedDossierContext, useDossierDocumentSignContext } from '../../../providers';
import DownloadableDocumentsList from '../DownloadableDocumentsList/DownloadableDocumentsList';
import { DisplayedDocument } from '../../../providers/types';
import useDossierFile from '../../../hooks/useDossierFile';
import useDocumentSign from '../../../hooks/useDocumentSign';
import useDocumentSignRender from '../../../hooks/useDocumentSignRender';

export interface DownloadableDocumentsTabPros {
    source?: 'BACK' | 'FRONT';
}

const DownloadableDocumentsTab: React.FunctionComponent<DownloadableDocumentsTabPros> = function ({
    source = 'BACK',
}: DownloadableDocumentsTabPros) {
    const [listItems, setListItems] = useState<Array<DisplayedDocument>>([]);
    const { dossier } = useSelectedDossierContext();
    const { handleSignSingleDocument } = useDocumentSign();
    const { showSignedDocument } = useDocumentSignRender();
    const { getDossiersBySignedFileId } = useDossierDocumentSignContext();
    const { dosDocs, getDossierDocumentsByCategory } = useDossierDocumentsCtx();
    const { handleDownload, handleShow } = useDossierFile({
        listItems,
        setListItems,
        typeDoc: DOC_TYPE_DOWNLOADABLE,
        setIsSubmitting: () => {},
        source,
    });

    const handleSignSingleDocProxy = (label: string, fichierId: number, fileName?: string) => {
        handleSignSingleDocument(
            dossier.id as number,
            dossier.prescripteurId as number,
            dossier.prescripteurLibelle as string,
            dossier.prescripteurEmail as string,
            label,
            fichierId,
            fileName,
        );
    };

    const handleDownloadSigned = (fichierId: number, fileName: string) => {
        showSignedDocument(fichierId, fileName, getDossiersBySignedFileId(fichierId));
    };

    useEffect(() => {
        if (!dossier.id) {
            return;
        }

        setListItems([
            ...getDossierDocumentsByCategory({ categoryId: DOC_TYPE_DOWNLOADABLE }),
            ...getDossierDocumentsByCategory({
                categoryId: DOC_TYPE_DOWNLOADABLE,
                additionalDocs: true,
            }),
        ]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dosDocs, getDossiersBySignedFileId]);

    return (
        <CardSection
            header={
                <CardHeader
                    title="Documents remis"
                    titleSx={{
                        fontSize: '20px',
                        lineHeight: '28px',
                    }}
                    border={false}
                />
            }
            sxContent={{
                padding: '8px 32px 32px',
                display: 'flex',
                flexDirection: 'column',
                gap: '24px 0',
            }}
        >
            <DownloadableDocumentsList
                documents={listItems}
                onDownload={handleDownload}
                onShow={() => {}}
                onSign={handleSignSingleDocProxy}
                onDownloadSigned={handleDownloadSigned}
                onPreview={handleShow}
            />
        </CardSection>
    );
};

export default DownloadableDocumentsTab;
